import ScrollAnimation from "react-animate-on-scroll";
import { Col } from "react-bootstrap";

import section4Bg from "../../../../assets/pages/international/eu-vat-changes/section-4-bg.png";
import jumbotronBg from "../../../../assets/pages/international/shipping-to-eu/jumbotron-bg.png";
import { AnchorLink } from "../../../../components/AnchorLink/AnchorLink";
import { BulletList } from "../../../../components/BulletList/BulletList";
import { CardContainer } from "../../../../components/CardContainer/CardContainer";
import { DownloadBtn } from "../../../../components/DownloadBtn/DownloadBtn";
import { ExportFundamentalsHeader } from "../../../../components/ExportFundamentalsHeader/ExportFundamentalsHeader";
import { GetInTouch } from "../../../../components/GetInTouch/GetInTouch";
import { Section } from "../../../../components/Section/Section";
import { Body } from "../../../../components/Typography/Body";
import { Heading2 } from "../../../../components/Typography/Heading2";
import { Heading3 } from "../../../../components/Typography/Heading3";
import {
  ANIMATIONS,
  DEFAULT_ANIMATION_DELAY,
} from "../../../../constants/constants";
import { SHIPPING_TO_EU } from "../../../../router/constants";
import * as router from "../../../../router/constants";
import variables from "../../../../styles/colors.scss";
import { Heading1 } from "../../../../components/Typography/Heading1";

export const EuVatChanges = () => {
  return (
    <>
      <Section bgImg={jumbotronBg}>
        <Col md={12} className="text-center">
          <ScrollAnimation
            animateIn={ANIMATIONS.FADE_IN}
            delay={DEFAULT_ANIMATION_DELAY}
            animateOnce={true}
          >
            <ExportFundamentalsHeader
              headerText="EU Reform Guidance 2026"
              anchorLinkText="Shipping to the European Union"
              anchorLinkHref={SHIPPING_TO_EU}
            />
          </ScrollAnimation>
        </Col>
      </Section>

      <Section>
        <Col md={12}>
          <ScrollAnimation
            animateIn={ANIMATIONS.FADE_IN}
            delay={DEFAULT_ANIMATION_DELAY}
            animateOnce={true}
          >
            <Heading2>
              The EU is updating its customs rules to level the playing field
              for EU retailers. While these changes mean a shift in how duties
              are handled, DPD is here to ensure your international business
              keeps moving forward smoothly and without interruption. Here is
              everything you need to know to prepare your business, protect your
              customer experience, and unlock your international shipping
              potential.
            </Heading2>
          </ScrollAnimation>
        </Col>
      </Section>

      <Section bgColor={variables.darkShade1}>
        <Col md={12}>
          <ScrollAnimation
            animateIn={ANIMATIONS.FADE_IN}
            delay={DEFAULT_ANIMATION_DELAY}
            animateOnce={true}
          >
            <Heading3>What is changing?</Heading3>
            <Body>
              The European Union is rolling out a series of regulatory updates
              across 2026 as part of its ongoing customs modernisation
              initiative. Effective from 1 July 2026
            </Body>
            <CardContainer
              cards={[
                {
                  cardText: (
                    <BulletList
                      listItems={[
                        {
                          text: "Removal of the €150 threshold for B2B and B2C: The current duty-free exemption for low-value imports will be completely withdrawn.",
                        },
                        {
                          text: "Flat-rate customs duty: A fixed duty charge per individual item will be introduced for B2C low-value consignments. B2B low-value consignments will become subject to usual ad-valorem rates.",
                        },
                        {
                          text: "Stricter data demands: There will be a significantly higher focus on precise product classification and the accuracy of customs data.",
                        },
                      ]}
                    />
                  ),
                },
              ]}
            />
          </ScrollAnimation>
        </Col>
      </Section>

      <Section>
        <Col md={12}>
          <ScrollAnimation
            animateIn={ANIMATIONS.FADE_IN}
            delay={DEFAULT_ANIMATION_DELAY}
            animateOnce={true}
          >
            <Heading3>Keep up to date with the useful links below:</Heading3>
            <Body>
              <AnchorLink externalLink={true} to={router.EU_TAXATION_CUSTOMS}>
                European Commission
              </AnchorLink>{" "}
              – Taxation and Customs Union Access the primary portal for
              official legislative updates, guidelines, and announcements
              regarding the Union Customs Code (UCC) modernisation programme.
            </Body>
            <Body>
              <AnchorLink externalLink={true} to={router.EU_GUIDANCE}>
                European Commission
              </AnchorLink>{" "}
              – Import One-Stop Shop (IOSS) Review the comprehensive rules,
              registration processes, and compliance frameworks governing
              distance sales and VAT simplification across EU member states.
            </Body>
            <Body>
              <AnchorLink externalLink={true} to={router.EU_ACCESS2MARKETS}>
                Access2Markets Portal
              </AnchorLink>{" "}
              – European Union Utilise the official tool for confirming precise
              Harmonised System (HS) product codes, customs tariffs, and
              country-of-origin rules required for accurate data validation.
            </Body>
          </ScrollAnimation>
        </Col>
      </Section>

      <Section bgImg={section4Bg}>
        <Col md={6}>
          <ScrollAnimation
            animateIn={ANIMATIONS.FADE_IN}
            delay={DEFAULT_ANIMATION_DELAY}
            animateOnce={true}
          >
            <Heading1>
              We&apos;ve also produced this useful guide to help you understand
              the changes
            </Heading1>
            <DownloadBtn downloadLink={router.DPD_EU_REFORM_GUIDANCE}>
              DPD EU Guidance (1.43mb)
            </DownloadBtn>
          </ScrollAnimation>
        </Col>
      </Section>

      <GetInTouch />
    </>
  );
};
